export default __webpack_public_path__ + "static/kz-8e060ebaca712d1fea76cfc4e77acbf3.svg";